export const EarlyPayoutDispatcherEvent = {
    CashOut: {
        Updated: 'EARLY_PAYOUT_UPDATED',
        PushToLower: 'EARLYPAYOUT_PUSH_TOLOWER',
        EarlyPayoutSuccess: 'EARLY_PAYOUT_SUCCESS',
        EarlyPayoutFailed: 'EARLY_PAYOUT_FAILED',
        CashOutAlreadyExecuted: 'CASH_OUT_ALREADY_EXECUTED',
    },
};
